import React from "react";
import Control from "../../common/Control";
import PostalCode from "../PostalCode";
import GroupedDigitControl from "../GroupedDigitControl";
import { questionTypeName } from "./formLogic";

const EMAIL_SENTINEL = "useAlreadyExistingEmail@cafreunion.re";

/*
  Rend le contrôle d'une question du formulaire : l'intitulé de la question est
  le libellé (ou la légende) du contrôle, la description et l'explication en
  sont l'aide, l'identifiant est `q<id>`. Toute la mécanique d'accessibilité
  (aria-describedby, aria-invalid, role="alert") vient de Control.
*/
const AnswerInterpretor = ({ question, inputTypes, updateAnswer, answer, errors }) => {
  const type = questionTypeName(question, inputTypes);
  const id = "q" + question.id;
  const hint =
    question.explication || question.description ? (
      <>
        {question.explication && (
          <p className="question_explication">{question.explication}</p>
        )}
        {question.description && (
          <p className="question_description">{question.description}</p>
        )}
      </>
    ) : null;

  if (type === "postalCode") {
    return (
      <PostalCode
        id={id}
        inputLabel={question.question}
        hint={hint}
        value={answer.value}
        updateData={updateAnswer}
        name={question.id}
        error={errors}
        margin="my-3"
      />
    );
  }

  if (type === "nir") {
    const errorMessage = errors && errors[question.id];
    return (
      <div className="form-group my-3">
        <label htmlFor={id} className="control-label">
          {question.question}
        </label>
        {hint && (
          <div className="control-hint" id={id + "-hint"}>
            {hint}
          </div>
        )}
        <div className="row m-0">
          <div className="col-12 col-md-6 col-lg-6">
            <img
              style={{ maxHeight: 196 }}
              className="img-fluid mb-3"
              src="/assets/carte-vitale.png"
              alt="spécimen de carte vitale"
            />
          </div>
          <div className="col-12 col-md-6 col-lg-6">
            <p className="text-primary">
              Votre numéro de sécurité sociale figure sur la face recto de votre
              carte vitale (cf image).
            </p>
          </div>
        </div>
        <GroupedDigitControl
          id={id}
          name={question.id}
          value={answer.value}
          separation={[1, 2, 2, 2, 3, 3, 2]}
          separator={"   "}
          change={updateAnswer}
          inputProps={{
            "aria-describedby":
              [hint ? id + "-hint" : "", errorMessage ? id + "-error" : ""]
                .filter(Boolean)
                .join(" ") || undefined,
            "aria-invalid": errorMessage ? "true" : undefined,
          }}
        />
        <small id={id + "-error"} role="alert" className="form-text text-danger">
          {errorMessage || null}
        </small>
      </div>
    );
  }

  return (
    <Control
      label={question.question}
      hint={hint}
      id={id}
      name={question.id}
      type={type}
      datas={question.answers}
      dataIndex={"value"}
      dataLabel={"label"}
      inputParams={question.inputParams}
      groups={question.groups}
      change={updateAnswer}
      checked={Boolean(answer.value)}
      value={answer.value === EMAIL_SENTINEL ? "" : answer.value}
      error={errors}
      allDefaultsText={question.allDefaultsText}
      margin="my-3"
    />
  );
};

export { EMAIL_SENTINEL };
export default AnswerInterpretor;
